(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer_backup"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll_Back() {
      // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // if (theme.config.mqlSmall || this.scrollUpActive) {
      //   if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      //     requestAnimationFrame(this.hide.bind(this));
      //   }
      //   else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      //     if (!this.preventReveal) {
      //       requestAnimationFrame(this.reveal.bind(this));
      //     }
      //     else {
      //       window.clearTimeout(this.isScrolling);
      //       this.isScrolling = setTimeout(() => {
      //         this.preventReveal = false;
      //       }, 66);
      //       requestAnimationFrame(this.hide.bind(this));
      //     }
      //   }
      //   else if (scrollTop <= this.headerBounds.top) {
      //     requestAnimationFrame(this.reset.bind(this));
      //     requestAnimationFrame(this.reveal.bind(this));
      //   }
      // }
      // else {
      //   if (scrollTop > this.headerBounds.bottom) {
      //     if (this.sticky()) return;
      //     requestAnimationFrame(this.hide.bind(this));
      //     setTimeout(() => {
      //       requestAnimationFrame(this.reveal.bind(this));
      //     }, 300);
      //   }
      //   else if (scrollTop <= this.headerBounds.top) {
      //     requestAnimationFrame(this.reset.bind(this));
      //   }
      // }
      // this.currentScrollTop = scrollTop;
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.reveal.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          requestAnimationFrame(this.hide.bind(this));
          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reveal_A() {
      // 检查 header 的 classList 是否已经包含 'shopify-section-header-sticky'
      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
      }
    
      // 检查 header 的 classList 是否不包含 'shopify-section-header-hidden'
      if (this.header.classList.contains('shopify-section-header-hidden')) {
        this.header.classList.remove('shopify-section-header-hidden');
      }
    
      // 检查 document.body 的 classList 是否已经包含 'shopify-body-section-header-sticky'
      if (!document.body.classList.contains('shopify-body-section-header-sticky')) {
        document.body.classList.add('shopify-body-section-header-sticky');
      }
    
      // 检查 document.body 的 classList 是否不包含 'shopify-body-section-header-hidden'
      if (document.body.classList.contains('shopify-body-section-header-hidden')) {
        document.body.classList.remove('shopify-body-section-header-hidden');
      }
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-scene-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-scene-media')) {
    customElements.define('product-scene-media', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.initializeGallery();
        this.video = this.querySelector('video');
        this.button = this.querySelector('.product-scenes__toggle');
        if (!this.video || !this.button || !('IntersectionObserver' in window)) return;
        this.videoInitialized = true;
        this.visible = false;
        this.userPaused = false;
        this.userStarted = false;
        this.automaticPlay = false;
        this.automaticPause = false;
        this.onToggle = () => {
          if (this.video.paused) {
            this.userStarted = true;
            this.userPaused = false;
            this.requestPlayback(true);
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        };
        this.onPlay = () => {
          if (!this.automaticPlay) {
            this.userStarted = true;
            this.userPaused = false;
          }
          this.updateButton();
        };
        this.onPause = () => {
          if (this.automaticPause) this.automaticPause = false;
          else this.userPaused = true;
          this.updateButton();
        };
        this.onVisibility = () => this.updatePlayback();
        this.onMotion = () => this.updatePlayback();
        this.button.addEventListener('click', this.onToggle);
        this.video.addEventListener('play', this.onPlay);
        this.video.addEventListener('pause', this.onPause);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
        this.video.controls = false;
        this.button.hidden = false;
        this.updateButton();
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
          this.updatePlayback();
        }, { threshold: [0, 0.2] });
        this.observer.observe(this.video);
      }
      initializeGallery() {
        this.gallery = this.querySelector('.product-scenes__images');
        this.galleryItems = Array.from(this.querySelectorAll('.product-scenes__image'));
        this.previousButton = this.querySelector('.product-scenes__arrow--previous');
        this.nextButton = this.querySelector('.product-scenes__arrow--next');
        this.galleryStatus = this.querySelector('.product-scenes__status');
        if (!this.gallery || this.galleryItems.length < 2 || !this.previousButton || !this.nextButton) return;
        this.galleryInitialized = true;
        this.galleryIndex = Math.min(this.galleryIndex || 0, this.galleryItems.length - 1);
        this.galleryMobile = matchMedia('(max-width: 749px)');
        this.onPrevious = () => {
          if (!this.galleryProgrammatic) this.synchronizeGallery();
          this.showImage(this.galleryIndex - 1, true);
        };
        this.onNext = () => {
          if (!this.galleryProgrammatic) this.synchronizeGallery();
          this.showImage(this.galleryIndex + 1, true);
        };
        this.onGalleryKey = event => {
          if (!this.galleryMobile.matches || event.altKey || event.ctrlKey || event.metaKey) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          if (!this.galleryProgrammatic) this.synchronizeGallery();
          const indexes = { ArrowLeft: this.galleryIndex - 1, ArrowRight: this.galleryIndex + 1, Home: 0, End: this.galleryItems.length - 1 };
          event.preventDefault();
          this.showImage(indexes[event.key], true);
        };
        this.onGalleryMode = () => this.showImage(this.galleryIndex, false);
        this.onGalleryInteraction = () => { this.galleryProgrammatic = false; };
        this.onGalleryScroll = () => {
          if (!this.galleryMobile.matches) return;
          clearTimeout(this.galleryScrollTimeout);
          this.galleryScrollTimeout = setTimeout(() => this.synchronizeGallery(), 120);
        };
        this.previousButton.addEventListener('click', this.onPrevious);
        this.nextButton.addEventListener('click', this.onNext);
        this.gallery.addEventListener('scroll', this.onGalleryScroll, { passive: true });
        this.gallery.addEventListener('pointerdown', this.onGalleryInteraction, { passive: true });
        this.gallery.addEventListener('wheel', this.onGalleryInteraction, { passive: true });
        this.gallery.parentElement.addEventListener('keydown', this.onGalleryKey);
        this.galleryMobile.addEventListener('change', this.onGalleryMode);
        if ('ResizeObserver' in window) {
          this.galleryResize = new ResizeObserver(this.onGalleryMode);
          this.galleryResize.observe(this.gallery);
        } else {
          window.addEventListener('resize', this.onGalleryMode);
        }
        this.showImage(this.galleryIndex, false);
      }
      showImage(index, animate) {
        clearTimeout(this.galleryScrollTimeout);
        this.updateGallery(index);
        this.galleryProgrammatic = animate && !this.motion.matches;
        this.gallery.scrollTo({
          left: this.galleryItems[this.galleryIndex].offsetLeft - this.galleryItems[0].offsetLeft,
          behavior: animate && !this.motion.matches ? 'smooth' : 'auto'
        });
      }
      synchronizeGallery() {
        if (!this.galleryMobile.matches) return;
        const origin = this.galleryItems[0].offsetLeft;
        const maximum = Math.max(0, this.gallery.scrollWidth - this.gallery.clientWidth);
        let nearestIndex = 0;
        let nearestDistance = Infinity;
        this.galleryItems.forEach((item, index) => {
          const position = Math.max(0, Math.min(item.offsetLeft - origin, maximum));
          const distance = Math.abs(position - this.gallery.scrollLeft);
          if (distance < nearestDistance) {
            nearestIndex = index;
            nearestDistance = distance;
          }
        });
        this.updateGallery(nearestIndex);
        this.galleryProgrammatic = false;
      }
      updateGallery(index) {
        this.galleryIndex = Math.max(0, Math.min(index, this.galleryItems.length - 1));
        const mobile = this.galleryMobile.matches;
        this.previousButton.hidden = !mobile;
        this.nextButton.hidden = !mobile;
        this.previousButton.disabled = this.galleryIndex === 0;
        this.nextButton.disabled = this.galleryIndex === this.galleryItems.length - 1;
        this.galleryItems.forEach((item, itemIndex) => {
          if (mobile && itemIndex !== this.galleryIndex) item.setAttribute('aria-hidden', 'true');
          else item.removeAttribute('aria-hidden');
        });
        if (this.galleryStatus) {
          this.galleryStatus.hidden = !mobile;
          this.galleryStatus.textContent = this.galleryStatus.dataset.statusTemplate.replace('__current__', this.galleryIndex + 1);
        }
      }
      updateButton() {
        const label = this.video.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        this.button.textContent = label;
        this.button.setAttribute('aria-label', label);
      }
      updatePlayback() {
        if (!this.visible || document.hidden || (this.motion.matches && !this.userStarted)) {
          this.pauseAutomatic();
        } else if (!this.userPaused) {
          this.requestPlayback(false);
        }
      }
      pauseAutomatic() {
        if (this.video.paused) return;
        this.automaticPause = true;
        this.video.pause();
      }
      async requestPlayback(manual) {
        if (this.playPending || !this.video.paused) return;
        this.playPending = true;
        this.automaticPlay = !manual;
        try {
          await this.video.play();
        } catch (error) {
          this.video.controls = true;
        } finally {
          this.playPending = false;
          this.automaticPlay = false;
          if (document.hidden || (!manual && !this.visible)) this.pauseAutomatic();
          this.updateButton();
        }
      }
      disconnectedCallback() {
        if (!this.initialized) return;
        if (this.galleryInitialized) {
          clearTimeout(this.galleryScrollTimeout);
          this.previousButton.removeEventListener('click', this.onPrevious);
          this.nextButton.removeEventListener('click', this.onNext);
          this.gallery.removeEventListener('scroll', this.onGalleryScroll);
          this.gallery.removeEventListener('pointerdown', this.onGalleryInteraction);
          this.gallery.removeEventListener('wheel', this.onGalleryInteraction);
          this.gallery.parentElement.removeEventListener('keydown', this.onGalleryKey);
          this.galleryMobile.removeEventListener('change', this.onGalleryMode);
          if (this.galleryResize) this.galleryResize.disconnect();
          else window.removeEventListener('resize', this.onGalleryMode);
          this.previousButton.hidden = true;
          this.nextButton.hidden = true;
          if (this.galleryStatus) this.galleryStatus.hidden = true;
          this.galleryItems.forEach(item => item.removeAttribute('aria-hidden'));
          this.galleryInitialized = false;
          this.galleryProgrammatic = false;
          this.galleryMobile = null;
          this.galleryResize = null;
        }
        if (this.videoInitialized) {
          this.observer.disconnect();
          this.pauseAutomatic();
          this.button.removeEventListener('click', this.onToggle);
          this.video.removeEventListener('play', this.onPlay);
          this.video.removeEventListener('pause', this.onPause);
          document.removeEventListener('visibilitychange', this.onVisibility);
          this.motion.removeEventListener('change', this.onMotion);
          this.video.controls = true;
          this.button.hidden = true;
          this.videoInitialized = false;
        }
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
